export enum CarePathType {
    flex = 'flex',
    old = 'old',
}
